module.exports = __webpack_public_path__ + "static/media/white-arrow.b90354c5.svg";